'use client';
import React from 'react';
import useHeaderStore from '@/store/header';
import { LoadingOverlay } from '@mantine/core';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { twMerge } from 'tailwind-merge';

function ApexImageLoader() {
  return <Image width={200} height={200} src="/images/apex.gif" alt="image loader" quality={100} unoptimized={true} />;
}

export default function MainComponent({ children }: { children: React.ReactNode }) {
  const showloaderOverlay = useHeaderStore((state) => state.showloaderOverlay);
  const pathname = usePathname();

  return (
    <>
      <LoadingOverlay
        visible={showloaderOverlay}
        overlayProps={{
          style: {
            backdropFilter: 'blur(1px)',
          },
        }}
        loaderProps={{ children: <ApexImageLoader /> }}
      />
      <div
        className={`${
          process.env.NEXT_PUBLIC_MAINTENANCE_MODE === 'false'
            ? `mb-12 flex h-fit flex-grow max-xs:mb-8 ` + (pathname !== '/' && 'pt-8 md:pt-20 lg:pt-8')
            : 'h-screen'
        } `}
      >
        <div
          className={twMerge(
            'max-w-full flex-grow pt-[calc(var(--header-height)_+_var(--location-bar-height)_+_var(--announcement-bar-height,0px))] lg:pt-[calc(var(--preheader-height)+var(--announcement-bar-height))]',
            process.env.NEXT_PUBLIC_MAINTENANCE_MODE == 'true' ? 'flex h-full flex-col' : '',
          )}
        >
          {children}
        </div>
      </div>
    </>
  );
}
